import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

export const Footer = () => {
  return (
    <footer className="bg-[#0B1D33] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Company */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-5">
              <div className="relative">
                <div className="absolute inset-0 bg-[#3B82A0]/25 rounded-full blur-lg scale-150" />
                <div className="absolute inset-0 rounded-full shadow-[0_0_12px_2px_rgba(59,130,160,0.35)]" />
                <img
                  src="/logo.png"
                  alt="CISO Dynamics"
                  className="relative w-14 h-14 rounded-full object-cover"
                />
              </div>
              <span className="text-base tracking-[0.05em]"><span className="font-semibold">CISO</span> <span className="font-light">Dynamics</span></span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Strategic cybersecurity advisory for executive leadership and enterprise organizations.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400 mb-5">
              Practice Areas
            </h4>
            <ul className="space-y-3">
              {[
                'Compliance Advisory',
                'Executive Advisory',
                'Program Development',
                'Platform Solutions',
                'Risk Operations',
                'Strategy & Readiness',
              ].map((item) => (
                <li key={item}>
                  <Link
                    to="/services"
                    className="text-slate-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400 mb-5">
              Firm
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Our Approach', path: '/approach' },
                { label: 'Industries', path: '/industries' },
                { label: 'Insights', path: '/insights' },
                { label: 'Contact', path: '/contact' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-slate-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400 mb-5">
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/contact"
                  className="text-slate-400 hover:text-white text-sm transition-colors duration-200 inline-flex items-center gap-1.5"
                >
                  Request a Consultation
                  <ArrowUpRight className="h-3.5 w-3.5" />
                </Link>
              </li>
              <li>
                <span className="text-slate-400 text-sm">info@cisodynamics.com</span>
              </li>
              <li>
                <span className="text-slate-400 text-sm">Washington, D.C.</span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-12 bg-white/10" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} CISO Dynamics. All rights reserved.
          </p>
          <div className="flex gap-8">
            <a
              href="#"
              className="text-slate-500 hover:text-slate-300 text-xs transition-colors duration-200"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-slate-500 hover:text-slate-300 text-xs transition-colors duration-200"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
